import { curry } from 'ramda';

import { IAppState } from '../../../AppModulesWrapper';

import { EServiceId } from '../../types/reducers/publishTerms';
import { selectServiceById } from '../publishTerms';

export const selectBaseAuctionBetByServiceId = curry((serviceId: EServiceId, state: IAppState): number => {
  const service = selectServiceById(serviceId, state);

  return service?.baseAuctionBet || 0;
});
